import { ToggleGroup } from '@pesto/ui/components/ToggleGroup';
import { cn } from '@pesto/utils';

export type SegmentOption<Value extends string> = { label: string; value: Value; selectedClassName?: string };

interface SegmentedFieldProps<Value extends string> {
  label: string;
  options: Array<SegmentOption<Value>>;
  value?: Value;
  onChange: (value: Value) => void;
  error?: string;
  required?: boolean;
}

export const SegmentedField = <Value extends string>({
  label,
  options,
  value,
  onChange,
  error,
  required,
}: SegmentedFieldProps<Value>) => (
  <div className="space-y-2">
    <div className={cn('flex text-sm font-medium leading-none', error && 'text-destructive')}>
      {label}
      {required && <span className="text-destructive ml-1">*</span>}
    </div>

    <ToggleGroup
      name={label}
      options={options}
      value={value}
      onChange={(next) => {
        const option = options.find((candidate) => candidate.value === next);

        if (option) onChange(option.value);
      }}
      className={cn('grid w-full grid-cols-2', error && 'ring-destructive ring-1')}
    />

    {error && <p className="text-destructive text-sm">{error}</p>}
  </div>
);
